import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import {
  SET_HISTORY,
  SET_LOCATION_STATE,
  UPDATE_LOCATION_STATE,
  SET_HISTORY_AND_LOCATION_STATE,
  SET_COMBINED_ROUTE_PARAMS,
} from './AppRoutesActions';

const initialState = {
  history: null,
  locationState: {}, // params from history.push({..., state: { stateParam1: 'test' }})
  routeParams: {}, // params from route path, e.g. /login/:action/:token
  locationSearch: {}, // params from search string, e.g. /login?action=login&token=123
  trackingPathName: null, // path name for tracking eg  for /search/quick/results it will be main.search.quick.results
};

// eslint-disable-next-line default-param-last
const routerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMBINED_ROUTE_PARAMS: {
      const { locationState, routeParams, locationSearch, trackingPathName } = action.payload;
      return {
        ...state,
        locationState,
        routeParams,
        locationSearch,
        trackingPathName,
      };
    }
    case SET_HISTORY_AND_LOCATION_STATE: {
      const locationState = get(action.payload, 'location.state', {});
      return {
        ...state,
        history: cloneDeep(action.payload),
        locationState: cloneDeep(locationState),
      };
    }
    case SET_HISTORY:
      return {
        ...state,
        history: cloneDeep(action.payload),
      };
    case SET_LOCATION_STATE:
      return {
        ...state,
        locationState: cloneDeep(action.payload),
      };
    case UPDATE_LOCATION_STATE:
      return {
        ...state,
        locationState: state.locationState ? { ...state.locationState, ...cloneDeep(action.payload) } : { ...cloneDeep(action.payload) },
      };
    default:
      return state;
  }
};

export default routerReducer;
